var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "panel-tag mt-2" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.__t("GOOGLE_LOCATION_PARAMS")) + "\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group mt-4 pt-4 mb-4 pb-4" },
      [
        _c("b-overlay", { attrs: { show: _vm.is_load } }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "glovo_location" } },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.__t("GOOGLE_REST")) +
                  "*\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.ext_restaurants.length > 0
            ? _c(
                "div",
                {},
                [
                  _c("v-select", {
                    staticClass: "imc_reasons",
                    attrs: {
                      reduce: function (item) {
                        return String(item.provider_id)
                      },
                      label: "provider_name",
                      filter: _vm.searchRest,
                      options: this.ext_restaurants,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function (option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _c("div", [
                                  _vm._v(_vm._s(option.location_name)),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(" " + _vm._s(option.provider_name)),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      743308974
                    ),
                    model: {
                      value: _vm.general_fields.store_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.general_fields, "store_id", $$v)
                      },
                      expression: "general_fields.store_id",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }